export default function({ rootState ,state, dispatch, commit }, { id, provider, questionnaire, emr_category }) {

    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + id + '/push',
        data: {
            emr_category,
            questionnaire
        }
    }, {
        root: true
    })
    .then((response) => {
        try {
            const pushed_by_id = rootState.auth.id
            const pushed_by = rootState.user.user.name
            const last_push_timestamp = Date.now()
            questionnaire.forEach(questionnaire_id => {
                commit('updateChartPushState', {
                    id,
                    questionnaire_id,
                    pushedState: {
                        pushed_by_id,
                        pushed_by,
                        last_push_timestamp
                    }
                })
            });
        } catch (error) {
            console.error(error)
        }
        return response
    })
    .catch((error) => {
        throw error
    })
}
